import { useTranslation } from 'react-i18next';
import { useNetworkStatus } from '../../services/networkStatus';
import type { DeliveryNote } from '../../types';
import { useDeliveryNoteActions } from './useDeliveryNoteActions';
import './DeliveryNoteSection.css';

/**
 * Las opciones del DDT en la tarjeta del contenedor (2026-10-23): un recuadro
 * aparte de Ocultar/Ver/Editar/VGM con solo lo del PDF — verlo, subirlo o
 * sustituirlo, y quitarlo. El DDT llega de la página (una petición por carga),
 * así que aquí no se pide nada; al cambiar, la página se entera por el evento
 * de la cola y vuelve a leer la lista.
 */
export function DeliveryNoteCardActions({
  idCargoDetail,
  idCargo,
  note,
  status,
}: {
  idCargoDetail: number;
  idCargo: number;
  note?: DeliveryNote;
  status?: 'done' | 'pending' | 'error';
}) {
  const { t } = useTranslation();
  const netStatus = useNetworkStatus();
  const isOnline = netStatus.kind !== 'offline' && netStatus.kind !== 'manual_offline';
  const { busy, message, pick, remove, fileInput } = useDeliveryNoteActions(idCargoDetail, idCargo);

  // Con algo pendiente de subir, lo que manda es eso y no lo que tenía el servidor.
  const hasNote = !!note && status === 'done';
  const replacing = hasNote || status === 'pending';

  return (
    <div className="ddt-box">
      <span className="ddt-box__label">{t('deliveryNote.short')}</span>
      {hasNote && isOnline && (
        <a className="action-btn action-btn--view" href={note!.url} target="_blank" rel="noreferrer noopener">
          {t('deliveryNote.viewPdf')}
        </a>
      )}
      <button type="button" className="action-btn action-btn--edit" onClick={pick} disabled={busy !== null}>
        {busy === 'upload' ? t('deliveryNote.uploading') : t(replacing ? 'deliveryNote.replace' : 'deliveryNote.upload')}
      </button>
      {hasNote && (
        <button type="button" className="action-btn action-btn--delete" onClick={remove} disabled={busy !== null}>
          {busy === 'remove' ? t('deliveryNote.removing') : t('deliveryNote.remove')}
        </button>
      )}
      {status === 'pending' && <span className="ddt-box__status ddt-box__status--pending">{t('deliveryNote.badgeTitle.pending')}</span>}
      {status === 'error' && <span className="ddt-box__status ddt-box__status--error">{t('deliveryNote.badgeTitle.error')}</span>}
      {message && <span className={`ddt-box__status ddt-box__status--${message.kind}`} role="status">{message.text}</span>}
      {fileInput}
    </div>
  );
}
